import { useCallback, useState, useEffect } from "react";

import moment from "../../Moment";

import { PassageFormError } from "../../interfaces/passage";

const useValidation = (date: string, hour: any, minutes: any) => {
  const [formError, setFormError] = useState<PassageFormError>({
    arrival_location_id: true,
    departure_location_id: true,
    date: false,
    hour: true,
    minutes: true,
    is_expired: false,
    car_id: true
  });

  const onValidation = useCallback(() => {
    const formValidation = Object.keys(formError).filter(field => {
      return formError[field];
    });

    return !(formValidation.length === 0);
  }, [formError]);

  useEffect(() => {
    const interval = setInterval(() => {
      const current = moment();
      const dateParsed = moment(date);
      const selected = moment([
        parseInt(dateParsed.format("YYYY")),
        parseInt(dateParsed.format("M")) - 1,
        parseInt(dateParsed.format("D")),
        hour,
        minutes
      ]);

      if (selected.isValid() && current.isAfter(selected, "minute")) {
        setFormError(prevFormError => ({
          ...prevFormError,
          is_expired: true
        }));
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [date, hour, minutes]);

  return {
    onValidation,
    setFormError,
    formError
  };
};

export default useValidation;
